module.exports = __webpack_public_path__ + "122d37c6e42f95d330e731e819549189.jpg";